import * as React from 'react';

import './Footer.scss';

class Footer extends React.Component {
  public render() {
    return <footer id="footer" />;
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer/Footer.tsx